import { createSelector } from 'reselect';
import { get as _get } from 'lodash';

import { selectFirestore } from 'services/selectors';

const defaultPartnersData = {
    value: '',
};

const selectPartners = state => state.partners;

export const selectPartnersFetching = createSelector(selectPartners, ({ fetching }) => fetching);

export const selectPartnersForUpdate = createSelector(selectFirestore, firestore =>
    _get(firestore, 'data.partners', defaultPartnersData),
);
